<template>
  <form-field
    :label="label"
    :validation-errors="validationErrors"
    :label-for="forId"
    :help-text="helpText"
    :show-label="showLabel"
    :show-value="showValue"
  >
    <slot name="before"></slot>
    <!-- https://buefy.org/documentation/select  -->
    <b-select
      v-bind="$attrs"
      :value="value"
      :id="forId"
      :size="size"
      expanded
      :loading="loading"
      :placeholder="placeholder"
      :disabled="disabled"
      :multiple="isMultiple"
      @input="handleInput"
      @focus="$emit('focus', $event)"
      @blur="$emit('blur', $event)"
    >
      <slot></slot>
    </b-select>
    <slot name="after"></slot>
  </form-field>
</template>

<script>
  import FormField from "./FormField";
  import {FormFieldMixin} from "./FormField.mixin";

  export default {
    name: "FormFieldSelect",
    components: {FormField},
    mixins: [FormFieldMixin],
    props: {
      value: {},
      placeholder: {
        type: String
      },
      label: {
        type: String,
      },
      validationErrors: {
        type: [String, Array, undefined],
      },
      helpText: {
        type: String
      },
      size: {
        type: String,
        default: 'is-small'
      },
      loading: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      isMultiple: {
        type: Boolean,
        default: false
      },
      showLabel: {
        type: String,
      },
      showValue: {
        type: String,
      },
    },
    data() {
      return {
        forId: this.$utils.generateClientId(),
      }
    },
    methods: {
      handleInput(val) {
        this.$emit('input', val);
        this.$emit('change', val);
        this.$emit('selected', val);

        this.emitGlobalFieldChangeEvent();
      },
    }
  }
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

::v-deep option[disabled] {
  color: $text-light;
}
</style>
